import axiosClient from "./axiosClient";

const contractUpload = {
  // tải lên hợp đồng đã tạo
  documentUpload: async (data) => {
    const url = `/document-upload/upload`;
    const response = await axiosClient.post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },

  // Tải xuống sách hợp đồng đã tạo
  documentDownload: async (params) => {
    const url = `/document-upload/download`;
    const response = await axiosClient.post(url, { params: params });
    return response;
  },
  // gửi email hợp đồng đã tạo
  sendEmailContractUpload: async (params) => {
    const url = `/document-upload/send-email`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  // Xem chi tiết hợp đồng đã tạo
  detailsContractUpload: async (id) => {
    const url = `/document-upload/view?id=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },
  // Xem hợp đồng đã tạo
  listContractUpload: async (params) => {
    const url = `document-upload/search`;
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  // Xóa hợp đồng đã tạo
  deleteContractUpload: async (params) => {
    const query = Object.keys(params)
      .map((key) => {
        const value = params[key];
        return Array.isArray(value)
          ? `${key}=${value.join(",")}`
          : `${key}=${value}`;
      })
      .join("&");
    const url = `/document-upload?${query}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
};

export default contractUpload;
